<tt-page *ngIf="!!page">
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="editUpdateTable"></ng-container>
        </tt-card>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card *ngIf="p2UpdateTableKeyno === '0'" ttHeading="h_update_table_new">
            <ng-container *ngTemplateOutlet="editUpdateTable"></ng-container>
        </tt-card>

        <tt-card *ngIf="p2UpdateTableKeyno !== '0'" ttHeading="h_update_table_edit">
            <ng-container *ngTemplateOutlet="editUpdateTable"></ng-container>
        </tt-card>
    </ng-container>
</tt-page>

<ng-template #editUpdateTable>
    <ng-container *ngIf="!!page">
        <tt-input ttLabel="p2_updatetable_keyno" [ttModel]="page.p2_updatetable_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="table_name" [(ttModel)]="page.table_name" ttRequired></tt-input>
        <tt-checkbox ttLabel="sync_data" [(ttModel)]="page.sync_data"></tt-checkbox>
        <tt-textarea *ngIf="page.sync_data === '1'" ttLabel="hashinfo" [ttModel]="page.hashinfo" ttReadonly></tt-textarea>
        <tt-input-number ttLabel="update_order" [(ttModel)]="page.update_order" ttDecimals="0"></tt-input-number>
        <tt-datetime ttLabel="reg_datetime" [ttModel]="page.reg_datetime" ttMinutePrecision="1" ttReadonly></tt-datetime>
        <tt-checkbox ttLabel="sync_use_load" [(ttModel)]="page.sync_use_load"></tt-checkbox>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </ng-container>
</ng-template>
